module.exports = __webpack_public_path__ + "img/8.303b9011.gif";